
import { defineComponent, ref, toRefs } from "vue-demi";
import SignupForm from "./SignupForm.vue";
import SuccessStep from "./SuccessStep.vue";
import { UnifiedResponseType } from "../DemoUniversalForm/api";

const STEPS = {
  SIGNUP_FORM_STEP: "SIGNUP_FORM_STEP",
  SUCCESS_FORM_STEP: "SUCCESS_FORM_STEP"
};

export default defineComponent({
  name: "marketing-registration-form",
  components: {
    SignupForm,
    SuccessStep
  },
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const { config } = toRefs(props);
    const currentStep = ref(STEPS.SIGNUP_FORM_STEP);
    const email = ref("");

    const handleSuccess = (data: UnifiedResponseType) => {
      // @ts-ignore
      const dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "Registration Success",
        client_id: data.client_id,
        profile_id: data.profile_id
      });

      if (config.value.redirectUrl) {
        document.location.href = config.value.redirectUrl;
      } else {
        email.value = data.email;
        currentStep.value = STEPS.SUCCESS_FORM_STEP;
      }
    };

    return {
      currentStep,
      handleSuccess,
      config,
      email,
      STEPS
    };
  }
});
